import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IResponseExternalWebhooks,
  type IParamsGetExternalWebhooks,
  type IParamsUpdateExternalWebhooks,
  type IParamsEventsPreview,
  type IResponseEventsPreview,
  type IParamsCreateExternalWebhooks,
  type IResponseExternalWebhook,
  type IParamsGetWebhookHistory,
  type IResponseWebhookHistory,
} from 'entities/Webhook/api/type'

export class Api {
  getExternalWebhooks(
    params: IParamsGetExternalWebhooks
  ): Promise<AxiosResponse<IResponseExternalWebhooks>> {
    return baseApi.get('external-webhooks/api/external-webhooks/list', {
      params,
    })
  }
  getExternalWebhookById(id: number): Promise<AxiosResponse<IResponseExternalWebhook>> {
    return baseApi.get(`external-webhooks/api/external-webhooks/${id}/view`)
  }
  updateExternalWebhooks(
    id: number,
    params: IParamsUpdateExternalWebhooks
  ): Promise<AxiosResponse<IResponseExternalWebhook>> {
    return baseApi.put(`external-webhooks/api/external-webhooks/${id}/update`, params)
  }

  deleteExternalWebhooks(id: number): Promise<AxiosResponse<IResponseExternalWebhooks>> {
    return baseApi.delete(`external-webhooks/api/external-webhooks/${id}/delete`)
  }

  getEventsPreview(params: IParamsEventsPreview): Promise<AxiosResponse<IResponseEventsPreview>> {
    return baseApi.get('external-webhooks/api/events/preview', {
      params,
    })
  }

  createExternalWebhooks(
    params: IParamsCreateExternalWebhooks
  ): Promise<AxiosResponse<IResponseExternalWebhook>> {
    return baseApi.post('external-webhooks/api/external-webhooks/create', params)
  }

  getWebhookHistory(
    webhookId: number,
    params: IParamsGetWebhookHistory
  ): Promise<AxiosResponse<IResponseWebhookHistory>> {
    return baseApi.get(`external-webhooks/api/external-webhooks/${webhookId}/requests-history`, {
      params,
    })
  }
}

export const WebhookApi = new Api()
